import React from "react";

export default function StudentService() {
  return <h1>学生服务</h1>;
}
